<div class="layout-row full-height" [ngClass]="{'overflow-y-auto': showRelatedTaskList}">

  <div class="flex layout-row"
       *ngIf="(task.taskType === 'Internal' || task.taskType === 'BundledStopover') && (isStartEndDay(task.taskSpec.purpose) || isStartEndRoute(task.taskSpec.purpose))">
    <!--Main Details-->
    <div class="flex layout-row main-container full-width"
         [ngClass]="{
              'disabled-task': task.analysis?.state === 'UnstartableDependent' || task.analysis?.state === 'UnstartableNoRoute',
              'highlight-task': isHighlighted}">

      <!--Purpose Color Div-->
      <div class="index-border margin-right-5"></div>

      <!--Index & Checkbox-->
      <div class="layout-row layout-align-center-center index-column margin-right-5">
        <bringoz-icon *ngIf="isStartEndRoute(task.taskSpec.purpose)"
                      iconName="route"
                      class="secondary-101"></bringoz-icon>
        <bringoz-icon *ngIf="isStartEndDay(task.taskSpec.purpose)"
                      [iconName]="task.taskSpec.purpose === 'StartDay' ? 'flag-start': 'flag-end'"></bringoz-icon>
      </div>

      <!--details container-->
      <div class="flex layout-column layout-align-center-start details-container margin-right-10">

        <div class="layout-row layout-align-start full-width">
          <app-task-purpose *ngIf="isStartEndRoute(task.taskSpec.purpose) && !task.taskSpec.depotReference?.id"
                            class="text-ellipsis info-row"
                            [purpose]="task.taskSpec.purpose">

          </app-task-purpose>

          <app-task-purpose *ngIf="isStartEndDay(task.taskSpec.purpose)"
                            class="text-ellipsis info-row"
                            [purpose]="task.taskSpec.purpose">
          </app-task-purpose>

          <span *ngIf="isStartEndRoute(task.taskSpec.purpose) && !!task.taskSpec.depotReference?.id"
                class="purpose-text br-body-1 font-weight-400">
                {{ task.taskSpec.purpose === 'StartRoute' ? 'Load at Depot' : 'Back to Depot' | translate }}
          </span>

          <div class="layout-row layout-align-start-center flex">
            <bringoz-icon [iconName]="!!task.taskSpec.depotReference?.id ? 'depot': 'location-pin'" fill="#0000008a"
                          class="margin-right-5"></bringoz-icon>
            <span class="flex br-body-1 font-weight-400 text-ellipsis" [ngbTooltip]="addressTooltip" openDelay="300"
                  triggers="hover">
             {{ task.taskSpec.address | bringozAddress }}
            </span>

            <ng-template #addressTooltip>
              {{ task.taskSpec.address | bringozAddress }}
            </ng-template>
          </div>
        </div>

        <!--Time Window/ service time-->
        <div class="layout-row layout-align-start-center"
             *ngIf="task.taskSpec.notBefore || task.taskSpec.notAfter">

          <bringoz-icon iconName="time-window-outline"
                        fill="#0000008a"
                        [ngbTooltip]="'Task time window' | translate" openDelay="300"
                        class="margin-right-5"
                        triggers="hover"></bringoz-icon>

          <span *ngIf="task.taskSpec.purpose === 'StartRoute'"
                class="br-body-1 font-weight-400">
                    {{ task.taskSpec | bringozDate: 'notBefore' }} {{ task.taskSpec | bringozTime: 'notBefore' }}
          </span>

          <span *ngIf="task.taskSpec.purpose === 'EndRoute' && task.taskSpec.notAfter"
                class="br-body-1 font-weight-400">
            {{ task.taskSpec | bringozDate: 'notAfter' }} {{ task.taskSpec | bringozTime: 'notAfter' }}
          </span>


          <app-bringoz-time-window-tooltip class="margin-left-10"
                                           [isTooltip]="true"
                                           [notBefore]="task.taskSpec.notBefore"
                                           [notAfter]="task.taskSpec.notAfter"
                                           [timeZoneId]="task.taskSpec.address?.zoneIdName"
                                           [configZoneId]="configZoneId">

          </app-bringoz-time-window-tooltip>


          <div *ngIf="task.taskSpec.serviceTime || task.taskSpec.detailedServiceTime"
               class="layout-row layout-align-start-center margin-left-5 gap-5">
            <bringoz-icon iconName="timer-outline"
                          classSize="md"
                          fill="#484848">

            </bringoz-icon>

            <div *ngIf="!task.taskSpec.detailedServiceTime" layout="row"
                 layout-align="start center" class="md-tiny">
              {{ task.taskSpec.serviceTime | bringozTimeConvert: true }}
            </div>

            <app-task-detailed-service-time *ngIf="!!task.taskSpec.detailedServiceTime"
                                            class="margin-left-5"
                                            [fontSize]="'md-tiny'"
                                            [isAllowEdit]="false"
                                            [detailedServiceTime]="task.taskSpec.detailedServiceTime">
            </app-task-detailed-service-time>
          </div>


        </div>

        <div *ngIf="logisticsVehiclesRefList?.length > 0" class="layout-row layout-align-start-center">
          <app-bringoz-state-link *ngFor="let vehicleRef of logisticsVehiclesRefList; let last = last"
                                  [ngClass]="{'margin-right-5': !last}"
                                  [state]="'logistics-vehicle.vehicle-profile'"
                                  [params]="{id: vehicleRef?.id}"
                                  [permission]="'services.get'"
                                  [text]="vehicleRef?.name">
          </app-bringoz-state-link>

        </div>

      </div>

      <div class="layout-column layout-align-start-end extra-info-container">

        <div class="layout-row layout-align-start-center margin-bottom-5" *ngIf="task.status !== 'CourierDeparted'">
          <app-task-eta [task]="task"
                        [timeZoneId]="task.taskSpec.address?.zoneIdName"
                        [configZoneId]="configZoneId">
          </app-task-eta>
        </div>

        <!--Departed-->
        <div class="layout-row layout-align-start-center margin-bottom-5" *ngIf="task.status === 'CourierDeparted'">
          <span class="br-body-1 font-weight-400 margin-right-5" translate>Departed</span>
          <span class="br-body-1 font-weight-400">{{ task | bringozTime: 'agentDepartureTime' }}</span>
        </div>

        <!--Status-->
        <div class="layout-row layout-align-center-center margin-bottom-5">

          <ng-container *ngIf="isStartEndRoute(task.taskSpec.purpose)">
            <div *ngIf="enableAgentVehicleBinding"
                 ngbDropdown container="body">
              <bringoz-button type="tertiary"
                              id="dropdownBasic1"
                              (click)="$event.stopPropagation();"
                              ng-disabled=""
                              ngbDropdownToggle>
                <bringoz-icon iconName="menu"></bringoz-icon>
              </bringoz-button>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic1">

                <button ngbDropdownItem
                        [disabled]="!logisticsVehiclesRefList?.length"
                        (click)="onEditEquippedBound.emit({task: task, event: $event})">
                  <span class="br-body-2" translate>Edit Bound Equipment</span>
                </button>

              </div>
            </div>
          </ng-container>

          <app-task-status-button [task]="task"
                                  [allowStatusChangeAction]="!disableActions"
                                  [status]="task.status"
                                  [isSmall]="true"
                                  (onChange)="onChangeStatus($event.task, $event.status)">

          </app-task-status-button>
        </div>
      </div>

    </div>
  </div>

  <div class="flex layout-column" *ngIf="task.taskType === 'Stopover'" appBringozIdGenerator="itineraryTaskItem">
    <div class="flex main-container layout-row full-width"
         [ngClass]="{
              'disabled-task': task.analysis?.state === 'UnstartableDependent' || task.analysis?.state === 'UnstartableNoRoute',
              'highlight-task': isHighlighted}">

      <!--Purpose Color Div-->
      <div class="index-border margin-right-5" [ngClass]="task.taskSpec.purpose"></div>
      <div class="layout-column layout-align-center-center index-column margin-right-5">
        <span class="br-body-1">{{ taskIndex }}</span>
        <app-bringoz-checkbox *ngIf="task.status !== 'CourierDeparted' && !disableActions"
                              [isChecked]="isSelected"
                              [isDisabled]="task.analysis?.state == 'UnstartableDependent'"
                              (clickEvent)="onTaskSelectToggle.emit(task.id);$event.stopPropagation()">
        </app-bringoz-checkbox>

        <bringoz-icon *ngIf="task.analysis?.pinned" iconName="pin" fill="#0000008a"></bringoz-icon>
      </div>

      <!--details container-->
      <div class="flex layout-column layout-align-center-start details-container margin-right-10">
        <div class="round-card layout-row layout-align-start-center">
          <div class="layout-row layout-align-start-center"
               (mouseenter)="isShowCopyButton=true"
               (mouseleave)="isShowCopyButton=false">
            <app-bringoz-state-link *ngIf="purposeToServiceType[task.taskSpec.purpose] === serviceTypes.Delivery"
                                    [state]="'service.delivery.info'"
                                    [params]="{id: task.serviceId}"
                                    [permission]="'services.get'"
                                    [text]="isDisplayExternal && task.serviceExternalId ? task.serviceExternalId : task.serviceId">
            </app-bringoz-state-link>

            <app-bringoz-state-link *ngIf="purposeToServiceType[task.taskSpec.purpose] === serviceTypes.Operation"
                                    [state]="'service.operation.info'"
                                    [params]="{id: task.serviceId}"
                                    [permission]="'services.get'"
                                    [text]="isDisplayExternal && task.serviceExternalId ? task.serviceExternalId : task.serviceId">
            </app-bringoz-state-link>

            <app-text-copy-button
              [text]="isDisplayExternal && task.serviceExternalId ? task.serviceExternalId : task.serviceId"
              [isShowCopyBtn]="isShowCopyButton"></app-text-copy-button>
          </div>

          <!--Display ID-->
          <span *ngIf="task.serviceDisplayId" class="br-body-1 margin-left-5"
                [ngbTooltip]="task.serviceDisplayId"
                openDelay="300" triggers="hover">{{ task.serviceDisplayId }}
          </span>

          <span class="br-body-1 flex text-ellipsis margin-left-5"
                [ngbTooltip]="tooltipTmpl" openDelay="300" triggers="hover">
            {{ !!task.taskSpec.contact?.fullName ? task.taskSpec.contact.fullName : task.taskSpec.contact?.businessName | bringozCapitalize }}
          </span>

          <ng-template #tooltipTmpl>
            <div class="layout-row">
              {{ task.taskSpec.contact?.businessName }}
              <span
                *ngIf="task.taskSpec.contact?.businessName && task.taskSpec.contact?.fullName">/ {{ task.taskSpec.contact?.fullName }}</span>
            </div>
          </ng-template>

        </div>

        <div
          *ngIf="!itinerariesTaskSettings || (itinerariesTaskSettings  && itinerariesTaskSettings.sections?.timeAndLocation)"
          class="flex-sm-50 flex-xs-50 flex-25 layout-row layout-xs-column layout-align-start-center layout-align-xs-center-start">

          <div class="layout-row layout-align-start-center flex">
            <bringoz-icon iconName="location-pin-outline" fill="#0000008a" class="margin-right-5"></bringoz-icon>
            <span class="flex br-body-1 font-weight-400 text-ellipsis" [ngbTooltip]="addressTooltip" openDelay="300"
                  triggers="hover">
             {{ task.taskSpec.address | bringozAddress }}
            </span>

            <ng-template #addressTooltip>
              {{ task.taskSpec.address | bringozAddress }}
            </ng-template>
          </div>


          <div class="layout-row layout-align-start-center">

            <bringoz-icon iconName="time-window-outline"
                          fill="#0000008a"
                          [ngbTooltip]="'Task time window' | translate" openDelay="300"
                          class="margin-right-5"
                          triggers="hover"></bringoz-icon>


            <span *ngIf="task.status === 'CourierDeparted'" class="br-body-1 font-weight-400 margin-right-5">
            {{ task.taskSpec | bringozDate: 'notBefore' }}
          </span>

            <span class="br-body-1 font-weight-400"
                  [ngbTooltip]="dueTooltip"
                  openDelay="300"
                  triggers="hover">{{ task.taskSpec | timeWindow }}</span>
            <ng-template #dueTooltip>
              <span>{{ 'Due:' | translate }} {{ task.taskSpec.notBefore | bringozFullDate: 'notBefore' }}</span>
            </ng-template>

            <app-bringoz-time-window-tooltip [isTooltip]="true"
                                             [notBefore]="task.taskSpec.notBefore"
                                             [notAfter]="task.taskSpec.notAfter"
                                             [timeZoneId]="task.taskSpec.address?.zoneIdName"
                                             [configZoneId]="configZoneId">

            </app-bringoz-time-window-tooltip>


            <div *ngIf="task.taskSpec.serviceTime || task.taskSpec.detailedServiceTime"
                 class="layout-row layout-align-start-center margin-left-5 gap-5">
              <bringoz-icon iconName="timer-outline"
                            classSize="md"
                            fill="#484848">

              </bringoz-icon>

              <div *ngIf="!task.taskSpec.detailedServiceTime" layout="row"
                   layout-align="start center" class="md-tiny">
                {{ task.taskSpec.serviceTime | bringozTimeConvert: true }}
              </div>

              <app-task-detailed-service-time *ngIf="!!task.taskSpec.detailedServiceTime"
                                              class="margin-left-5"
                                              [fontSize]="'md-tiny'"
                                              [isAllowEdit]="false"
                                              [detailedServiceTime]="task.taskSpec.detailedServiceTime">
              </app-task-detailed-service-time>
            </div>
          </div>
        </div>

        <div
          *ngIf="!itinerariesTaskSettings || (itinerariesTaskSettings  && itinerariesTaskSettings.sections?.capacity)"
          class="layout-row layout-align-start-center full-width">

          <app-service-packed-indication *ngIf="!!task.packageList?.length && !!task.packageList[0]?.items?.length"
                                         [packageList]="task.packageList"
                                         [serviceType]="task.taskSpec.purpose"
                                         [isPacked]="task.serviceInfo?.autoGeneratedPacked"
                                         [packingInfo]="task.serviceInfo?.packingInfo"
                                         [packedDate]="task.serviceInfo?.packedDate">

          </app-service-packed-indication>

          <app-task-capacity-bars class="flex"
                                  *ngxPermissionsOnly="'fleetManagement.vehicles.list'"
                                  [currentLoad]="analysis?.currentLoad"></app-task-capacity-bars>

        </div>

        <div class="layout-row layout-align-start-center full-width">
          <!--          <span class="text-capitalize task-purpose-span text-ellipsis  br-body-1">-->
          <!--          {{'TASK_PURPOSE.' + task.taskSpec.purpose | translate}}-->
          <!--          </span>-->

          <app-task-purpose class="text-ellipsis info-row"
                            [purpose]="task.taskSpec.purpose">

          </app-task-purpose>
          <bringoz-icon
            *ngIf="task.relations?.length && !(task.analysis?.actualNotBefore >= task.analysis?.eta && task.analysis?.actualNotAfter <= task.analysis.eta)"
            iconName="error-outline" fill="#E57373" [ngbTooltip]="'Relation Time Mismatch' | translate"
            openDelay="300"
            triggers="hover">

          </bringoz-icon>

          <div class="layout-row layout-align-start-center">
            <bringoz-icon iconName="dollar-circle" fill="#0000008a" class="margin-right-5"></bringoz-icon>
            <span class="br-body-1 font-weight-400 text-ellipsis" [ngbTooltip]="'Courier Price' | translate"
                  openDelay="300"
                  triggers="hover">
              {{ task | taskCourierPrice }}
            </span>
          </div>

        </div>

        <div *ngIf="!itinerariesTaskSettings || (itinerariesTaskSettings  && itinerariesTaskSettings.sections?.tags)"
             class="layout-row layout-align-start-center full-width">
          <app-bringoz-tags [tags]="task.serviceInfo?.tagNames"></app-bringoz-tags>
        </div>

        <div *ngIf="itinerariesTaskSettings?.sections?.proNumber"
             class="layout-row layout-align-start-center full-width">
          <bringoz-icon iconName="hash"
                        classSize="md"
                        fill="#0000008a"
                        [ngbTooltip]="'proNumber' | translate"
                        openDelay="300"
                        triggers="hover"
                        class="margin-right-5"></bringoz-icon>
          <span *ngIf="proNumbers.length === 0" class="br-body-1 font-weight-400">---</span>
          <app-bringoz-items-list-display *ngIf="proNumbers.length > 0" [items]="proNumbers" [maxItems]="1" [isTransparentBackground]="true">
          </app-bringoz-items-list-display>
        </div>

      </div>

      <div class="layout-column layout-align-start-end extra-info-container">
        <div class="layout-row layout-align-start-center margin-bottom-5" *ngIf="task.status !== 'CourierDeparted'">
          <app-task-eta [task]="task"
                        [timeZoneId]="task.taskSpec.address?.zoneIdName"
                        [configZoneId]="configZoneId">
          </app-task-eta>
        </div>

        <!--Departed-->
        <div class="layout-column layout-align-center-start margin-bottom-5" *ngIf="task.status === 'CourierDeparted'">
          <span class="br-body-1 font-weight-400 margin-right-5" translate>Departed</span>
          <span class="br-body-1 font-weight-400">
              {{ task | bringozTime: 'agentDepartureTime' }}
        </span>
        </div>

        <!--Status-->
        <div class="layout-column layout-align-center-center margin-bottom-5">
          <app-task-status-button [task]="task"
                                  [allowStatusChangeAction]="!disableActions"
                                  [status]="task.status"
                                  [isSmall]="true"
                                  (onChange)="onChangeStatus($event.task, $event.status)">

          </app-task-status-button>
        </div>

        <!--Number Of Tasks-->
        <div *ngIf="!!task.relations?.length" class="layout-row layout-align-end-center"
             (click)="onClickRelatedTaskListToggle()">
          <div class="layout-row layout-align-start-center secondary-100">
            <span class="br-caption-2 margin-right-5">{{ 'Related' | translate }}:</span>
            <span class="br-caption-2">{{ task.relations.length }}</span>
          </div>
          <bringoz-icon [iconName]="showRelatedTaskList ? 'chevron-up': 'chevron-down'" fill="#0000008a"></bringoz-icon>

        </div>


      </div>
    </div>
    <!--Relations-->
    <div *ngIf="showRelatedTaskList" class="layout-column task-container fade-element-in-only">
      <app-task-relation-card class="flex" *ngFor="let relation of task.relations" [relation]="relation">

      </app-task-relation-card>
    </div>
  </div>

  <div *ngIf="task.taskType === 'BundledStopover' && !isStartEndDayOrRoute(task.taskSpec.purpose)"
       class="flex layout-column"
       appBringozIdGenerator="itineraryTaskBundleItem">

    <div class="flex layout-row main-container" [ngClass]="{
              'disabled-task': task.analysis?.state === 'UnstartableDependent' || task.analysis?.state === 'UnstartableNoRoute',
              'highlight-task': isHighlighted}">


      <!--Purpose Color Div-->
      <div class="index-border margin-right-5" [ngClass]="task.taskSpec.purpose"></div>

      <!--Index & Checkbox-->
      <div class="layout-column layout-align-center-center index-column margin-right-5">
        <span class="br-body-1">{{ taskIndex }}</span>
        <ng-container *ngxPermissionsOnly="'tasks.update'">
          <app-bringoz-checkbox *ngIf="task.status !== 'CourierDeparted' && !disableActions"
                                [isChecked]="isSelected"
                                [isDisabled]="task.analysis?.state == 'UnstartableDependent'"
                                (clickEvent)="onTaskSelectToggle.emit(task.id);$event.stopPropagation()">
          </app-bringoz-checkbox>
        </ng-container>

        <bringoz-icon *ngIf="task.analysis?.pinned" iconName="pin" fill="#0000008a"></bringoz-icon>
      </div>

      <!--details container-->
      <div class="flex layout-column layout-align-center-start details-container">

        <div class="round-card layout-row layout-align-start-center">
          <!--Display ID-->
          <span *ngIf="task.serviceDisplayId" class="br-body-1 text-ellipsis"
                [ngbTooltip]="task.serviceDisplayId"
                openDelay="300" triggers="hover">{{ task.serviceDisplayId }}
          </span>

          <span class="br-body-1 flex text-ellipsis margin-left-5"
                [ngbTooltip]="tooltipTmpl" openDelay="300" triggers="hover">
                         {{ task.taskSpec.contact?.fullName ? task.taskSpec.contact?.fullName : task.taskSpec.contact?.businessName | bringozCapitalize }}
          </span>

          <ng-template #tooltipTmpl>
            <div class="layout-row">
              {{ task.taskSpec.contact?.businessName }}
              <span
                *ngIf="task.taskSpec.contact?.businessName && task.taskSpec.contact?.fullName">/ {{ task.taskSpec.contact?.fullName }}</span>
            </div>
          </ng-template>
        </div>

        <div
          *ngIf="!itinerariesTaskSettings || (itinerariesTaskSettings  && itinerariesTaskSettings.sections?.timeAndLocation)"
          class="flex-sm-50 flex-xs-50 flex-25 layout-row layout-xs-column layout-align-start-center layout-align-xs-center-start">

          <div class="layout-row layout-align-start-center flex">
            <bringoz-icon iconName="location-pin-outline" fill="#0000008a" class="margin-right-5"></bringoz-icon>
            <span class="flex br-body-1 font-weight-400 text-ellipsis" [ngbTooltip]="addressTooltip" openDelay="300"
                  triggers="hover">
             {{ task.taskSpec.address | bringozAddress }}
          </span>

            <ng-template #addressTooltip>
              {{ task.taskSpec.address | bringozAddress }}
            </ng-template>
          </div>


          <div class="layout-row layout-align-start-center">

            <bringoz-icon iconName="time-window-outline"
                          fill="#0000008a"
                          [ngbTooltip]="'Task time window' | translate" openDelay="300"
                          class="margin-right-5"
                          triggers="hover"></bringoz-icon>


            <span *ngIf="task.status === 'CourierDeparted'" class="br-body-1 font-weight-400 margin-right-5">
            {{ task.taskSpec | bringozDate: 'notBefore' }}
          </span>

            <span class="br-body-1 font-weight-400"
                  [ngbTooltip]="dueTooltip"
                  openDelay="300"
                  triggers="hover">{{ task.taskSpec | timeWindow }}</span>
            <ng-template #dueTooltip>
              <span>{{ 'Due:' | translate }} {{ task.taskSpec.notBefore | bringozFullDate: 'notBefore' }}</span>
            </ng-template>

            <app-bringoz-time-window-tooltip [isTooltip]="true"
                                             [notBefore]="task.taskSpec.notBefore"
                                             [notAfter]="task.taskSpec.notAfter"
                                             [timeZoneId]="task.taskSpec.address?.zoneIdName"
                                             [configZoneId]="configZoneId">

            </app-bringoz-time-window-tooltip>

            <div *ngIf="task.taskSpec.serviceTime || task.taskSpec.detailedServiceTime"
                 class="layout-row layout-align-start-center margin-left-5 gap-5">
              <bringoz-icon iconName="timer-outline"
                            classSize="md"
                            fill="#484848">

              </bringoz-icon>
              <div *ngIf="!task.taskSpec.detailedServiceTime" layout="row"
                   layout-align="start center" class="md-tiny">
                {{ task.taskSpec.serviceTime | bringozTimeConvert: true }}
              </div>

              <app-task-detailed-service-time *ngIf="!!task.taskSpec.detailedServiceTime"
                                              class="margin-left-5"
                                              [fontSize]="'md-tiny'"
                                              [isAllowEdit]="false"
                                              [detailedServiceTime]="task.taskSpec.detailedServiceTime">
              </app-task-detailed-service-time>
            </div>
          </div>
        </div>

        <div
          *ngIf="!itinerariesTaskSettings || (itinerariesTaskSettings  && itinerariesTaskSettings.sections?.capacity)"
          class="layout-row layout-align-start-center full-width">

          <app-service-packed-indication *ngIf="!!task.packageList.length && !!task.packageList[0]?.items?.length"
                                         [packageList]="task.packageList"
                                         [serviceType]="task.taskSpec.purpose"
                                         [isPacked]="task.serviceInfo?.autoGeneratedPacked"
                                         [packingInfo]="task.serviceInfo?.packingInfo"
                                         [packedDate]="task.serviceInfo?.packedDate">

          </app-service-packed-indication>

          <app-task-capacity-bars class="flex"
                                  *ngxPermissionsOnly="'fleetManagement.vehicles.list'"
                                  [currentLoad]="analysis?.currentLoad"></app-task-capacity-bars>

        </div>

        <div class="flex-25 layout-row layout-align-start-center full-width">

          <div class="layout-column full-height task-purpose-span text-ellipsis  br-body-1">
            <app-task-purpose class="text-ellipsis info-row"
                              [isBundle]="task.taskType === 'BundledStopover'"
                              [purpose]="task.taskSpec.purpose">

            </app-task-purpose>
          </div>

          <app-entity-relations-indicator [task]="task"></app-entity-relations-indicator>

          <bringoz-icon
            *ngIf="task.relations?.length && !(task.analysis?.actualNotBefore >= task.analysis?.eta && task.analysis?.actualNotAfter <= task.analysis?.eta)"
            iconName="error-outline" fill="#E57373" [ngbTooltip]="'Relation Time Mismatch' | translate"
            openDelay="300"
            triggers="hover">

          </bringoz-icon>

          <div class="layout-row layout-align-start-center">
            <bringoz-icon iconName="dollar-circle" fill="#0000008a" class="margin-right-5"></bringoz-icon>
            <span class="br-body-1 font-weight-400 text-ellipsis" [ngbTooltip]="'Courier Price' | translate"
                  openDelay="300"
                  triggers="hover">
              {{ task | taskCourierPrice }}
            </span>
          </div>
        </div>

        <div *ngIf="itinerariesTaskSettings?.sections?.proNumber"
             class="layout-row layout-align-start-center full-width">
          <bringoz-icon iconName="hash"
                        classSize="md"
                        fill="#0000008a"
                        [ngbTooltip]="'proNumber' | translate"
                        openDelay="300"
                        triggers="hover"
                        class="margin-right-5"></bringoz-icon>
          <span *ngIf="proNumbers.length === 0" class="br-body-1 font-weight-400">---</span>
          <app-bringoz-items-list-display *ngIf="proNumbers.length > 0" [items]="proNumbers" [maxItems]="1" [isTransparentBackground]="true">
          </app-bringoz-items-list-display>
        </div>

      </div>

      <div class="layout-column layout-align-start-end extra-info-container">
        <div class="layout-row layout-align-start-center margin-bottom-5" *ngIf="task.status !== 'CourierDeparted'">
          <app-task-eta [task]="task"
                        [timeZoneId]="task.taskSpec.address?.zoneIdName"
                        [configZoneId]="configZoneId">
          </app-task-eta>
        </div>

        <!--Departed-->
        <div class="layout-column layout-align-center-start margin-bottom-5" *ngIf="task.status === 'CourierDeparted'">
          <span class="br-body-1 font-weight-400 margin-right-5" translate>Departed</span>
          <span class="br-body-1 font-weight-400">
              {{ task | bringozTime: 'agentDepartureTime' }}
        </span>
        </div>

        <!--Status-->
        <div class="layout-column layout-align-center-center margin-bottom-5">
          <app-task-status-button [task]="task"
                                  [allowStatusChangeAction]="!disableActions"
                                  [status]="task.status"
                                  [isSmall]="true"
                                  (onChange)="onChangeStatus($event.task, $event.status)">

          </app-task-status-button>
        </div>

        <!--Number Of Tasks-->
        <div class="layout-row layout-align-end-center"
             (click)="onClickBundledTaskListToggle()">
          <div class="layout-row layout-align-start-center" [ngClass]="task.taskSpec.purpose">
            <span class="br-caption-2 margin-right-5">{{ 'Tasks' | translate }}:</span>
            <span *ngIf="!!task.numberOfTasks" class="br-caption-2">{{ task.numberOfTasks }}</span>
          </div>
          <bringoz-icon [iconName]="showBundleTaskList ? 'chevron-up': 'chevron-down'"
                        [ngClass]="task.taskSpec.purpose"></bringoz-icon>

        </div>


      </div>

    </div>
    <div *ngIf="showBundleTaskList" class="layout-column fade-element-in-only">

      <hr class="margin-0 secondary-101">

      <div *ngFor="let task of bundledTaskList; let last = last" class="layout-column">

        <div class="flex layout-row layout-align-start-center padding-5">
          <span class="flex-10"></span>

          <div class="layout-column">

            <div class="flex layout-row layout-align-start-center">
              <app-task-purpose class="text-ellipsis"
                                [purpose]="task.taskSpec.purpose">

              </app-task-purpose>

              <app-entity-relations-indicator [task]="task"></app-entity-relations-indicator>

              <div class="layout-row layout-align-start-center"
                   (mouseenter)="isShowCopyButton=true"
                   (mouseleave)="isShowCopyButton=false">
                <app-bringoz-state-link *ngIf="purposeToServiceType[task.taskSpec.purpose] === serviceTypes.Delivery"
                                        class="flex text-ellipsis margin-left-5"
                                        [state]="'service.delivery.info'"
                                        [params]="{id: task.serviceId}"
                                        [permission]="'services.get'"
                                        [text]="isDisplayExternal && task.serviceExternalId ? task.serviceExternalId : task.serviceId">
                </app-bringoz-state-link>

                <app-bringoz-state-link *ngIf="purposeToServiceType[task.taskSpec.purpose] === serviceTypes.Operation"
                                        class="flex text-ellipsis margin-left-5"
                                        [state]="'service.operation.info'"
                                        [params]="{id: task.serviceId}"
                                        [permission]="'services.get'"
                                        [text]="isDisplayExternal && task.serviceExternalId ? task.serviceExternalId : task.serviceId">
                </app-bringoz-state-link>

                <app-text-copy-button [text]="task.serviceId" [isShowCopyBtn]="isShowCopyButton"></app-text-copy-button>
              </div>


              <!--Display ID-->
              <span *ngIf="task.serviceDisplayId"
                    class="br-body-1 flex layout-row layout-align-start-center info-row text-ellipsis margin-left-5">{{ task.serviceDisplayId }}
              </span>


            </div>

            <div class="flex layout-column layout-align-center-start">

              <!--Address-->
              <div *ngIf="!!task.taskSpec?.address"
                   class="layout-row layout-align-start-center text-ellipsis info-row">
                <bringoz-icon iconName="location-pin-outline" classSize="md"
                              [ngClass]="task.taskSpec.purpose"></bringoz-icon>
                <span class="flex br-body-1 font-weight-400 text-ellipsis"
                      [ngbTooltip]="task.taskSpec.address | bringozAddress"
                      openDelay="300" triggers="hover"
                >{{ task.taskSpec.address | bringozAddress }}</span>
              </div>

              <!--third-->
              <div class="flex-30 layout-row layout-align-start-center info-row">

                <div *ngIf="task.taskSpec.locationDetails?.locationType === locationTypes.ACCOUNT"
                     class="flex layout-row layout-align-start-center margin-right-5">
                  <bringoz-icon iconName="account" classSize="md" [ngClass]="task.taskSpec.purpose"></bringoz-icon>

                  <span appBringozPpi
                        class="br-body-1 margin-left-5 text-ellipsis secondary100">{{ task.taskSpec.contact | userName }}</span>
                </div>

                <div *ngIf="task.taskSpec.locationDetails?.locationType === locationTypes.DEPOT"
                     class="flex margin-right-5 layout-row layout-align-start-center">
                  <bringoz-icon iconName="depot" classSize="md" [ngClass]="task.taskSpec.purpose"></bringoz-icon>

                  <span
                    class="br-body-1 margin-left-5 text-ellipsis secondary100">{{ task.taskSpec.depotReference.name }}</span>
                </div>

                <div *ngIf="task.taskSpec.locationDetails?.locationType === locationTypes.CUSTOMER"
                     class="flex layout-row layout-align-start-center margin-right-5">
                  <bringoz-icon iconName="customer-outline" classSize="md"
                                [ngClass]="task.taskSpec.purpose"></bringoz-icon>

                  <span appBringozPpi
                        class="br-body-1 margin-left-5 text-ellipsis secondary100">{{ task.taskSpec.contact | userName }}</span>
                </div>

                <div *ngIf="task.taskSpec.locationDetails?.locationType === locationTypes.CUSTOM"
                     class="flex layout-row layout-align-start-center margin-right-5">
                  <bringoz-icon iconName="location-pin-plus-outline" classSize="md"
                                [ngClass]="task.taskSpec.purpose"></bringoz-icon>
                  <span appBringozPpi
                        class="br-body-1 margin-left-5 text-ellipsis secondary100">{{ task.taskSpec.contact | userName }}</span>
                </div>

                <!--Courier Price-->
                <div class="layout-row layout-align-start-center">
                  <bringoz-icon iconName="dollar-circle" fill="#0000008a" class="margin-right-5"></bringoz-icon>
                  <span class="br-body-1 font-weight-400 text-ellipsis" [ngbTooltip]="'Courier Price' | translate"
                        openDelay="300"
                        triggers="hover">
                    {{ task | taskCourierPrice }}
                  </span>
                </div>

              </div>

            </div>

          </div>
        </div>

        <hr *ngIf="!last" class="margin-0 secondary-101">

      </div>
    </div>

  </div>
</div>
